export function validationNIF(nif: string): boolean {
 // @ts-ignore
  return /^(\d{8})([A-HJ-NP-TV-Z])$/.test(nif) && ("TRWAGMYFPDXBNJZSQVHLCKE"[(RegExp.$1%23)]==RegExp.$2);
}

// export class CalculosDNICIF {
//   // Validates the CIF by calculating its control digit
//   ValidarCIF(cif) {
//       try {
//           let posPares = 0;
//           let posImpares = 0;
//           let sumaParesImpares;
//           let ultimoCaracter;
//           let pNumero;
//           const uLetra = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "0"];
//           const fLetra = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];
//           const fLetraNum = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
//           let tmpPos;

//           if (cif.length < 9) return false;

//           cif = cif.toUpperCase();
//           ultimoCaracter = cif.charAt(8);

//           let cont;
//           for (cont = 1; cont < 7; cont++) {
//               tmpPos = (2 * parseInt(cif.charAt(cont++))) + "0";
//               posImpares += parseInt(tmpPos.charAt(0)) + parseInt(tmpPos.charAt(1));
//               posPares += parseInt(cif.charAt(cont));
//           }

//           tmpPos = (2 * parseInt(cif.charAt(cont))) + "0";
//           posImpares += parseInt(tmpPos.charAt(0)) + parseInt(tmpPos.charAt(1));

//           sumaParesImpares = posPares + posImpares;
//           pNumero = parseInt(sumaParesImpares.toString().charAt(sumaParesImpares.toString().length - 1));
//           pNumero = 10 - pNumero;
//           if (pNumero === 10) pNumero = 0;

//           return (ultimoCaracter === pNumero.toString()) || (ultimoCaracter === uLetra[pNumero - 1]);
//       } catch (ex) {
//           console.warn("Error al validar CIF: " + ex.message);
//           return false;
//       }
//   }

//   // Obtains the letter corresponding to the number
//   static obtenerLetra(numero) {
//       const letras = {
//           0: "T", 1: "R", 2: "W", 3: "A", 4: "G", 5: "M", 6: "Y",
//           7: "F", 8: "P", 9: "D", 10: "X", 11: "B", 12: "N", 13: "J",
//           14: "Z", 15: "S", 16: "Q", 17: "V", 18: "H", 19: "L", 20: "C",
//           21: "K", 22: "E"
//       };
//       return letras[numero];
//   }

//   // Validates the NIF passed as a parameter
//   // Checks if the letter is correct

//   ValidarNIF(NIF) {
//       if (NIF === "") return false;

//       try {
//           // Get the letter of the NIF (the last character)
//           const letra = NIF.charAt(NIF.length - 1);
//           // Get the numbers from the NIF
//           NIF = NIF.substring(0, NIF.length - 1);
//           // Convert to number
//           const nifNum = parseInt(NIF);
//           const resto = nifNum % 23;
//           const letraResto = CalculosDNICIF.obtenerLetra(resto);

//           return letraResto.toUpperCase() === letra.toUpperCase();
//       } catch (ex) {
//           console.warn("Error al validar NIF: " + ex.message);
//           return false;
//       }
//   }
// }
